module.exports = __webpack_public_path__ + "IMG_8627.ab9f874d332966e7aeae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding/andy_jeska/IMG_8627.jpg
// module id = ./src/assets/images/wedding/andy_jeska/IMG_8627.jpg
// module chunks = main